import { createSlice } from '@reduxjs/toolkit';
import { HYDRATE } from 'next-redux-wrapper';

export const AVAILABILITY_PAGE_SIZE = 200;
export const AVAILABILITY_EXPORT_LIMIT = 100000;

// Initial state
const initialState = {
  filters: {
    urlParams: undefined,
    modalFiltersRules: undefined,
    modalConditions: undefined,
  },
};

// Actual Slice
export const availabilityTableSlice = createSlice({
  name: 'availabilityTable',
  initialState,
  reducers: {
    filtersModalChangeSuccess: (state, { payload }) => {
      state.filters.modalConditions = payload;
      if (!payload?.rules?.length) {
        state.filters.modalFiltersRules = undefined;
      }
    },
    filtersModalRulesAvailabilityChangeSuccess: (state, { payload }) => {
      state.filters.modalFiltersRules = payload;
    },
    resetModalChangeSuccess: (state) => {
      state.filters.modalConditions = null;
      state.filters.modalFiltersRules = null;
    },
    // Special reducer for hydrating the state. Special case for next-redux-wrapper
    extraReducers: {
      [HYDRATE]: (state, action) => {
        return {
          ...state,
          ...action.payload.errors,
        };
      },
    },
  },
});

export const {
  filtersModalChangeSuccess,
  filtersModalRulesAvailabilityChangeSuccess,
  resetModalChangeSuccess,
} = availabilityTableSlice.actions;

export const filtersModalConditionAvailabilityChange = (rules) => {
  return (dispatch) => {
    dispatch(filtersModalChangeSuccess(rules));
  };
};

export const filtersModalRulesAvailabilityChange = (rules) => {
  return (dispatch) => {
    dispatch(filtersModalRulesAvailabilityChangeSuccess(rules));
  };
};

export const resetModalAvailabilityChange = () => {
  return (dispatch) => {
    dispatch(resetModalChangeSuccess());
  };
};

export const selectAvailabilityTableState = (state) => state.availabilityTable;

export default availabilityTableSlice.reducer;
